module.exports = __webpack_public_path__ + "img/scene.2.layer2.43527bad.png";